/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { config } from './configReadonly.js';
import { createBigNumberClass, createComplexClass, createE, createFalse, createFineStructure, createFractionClass, createI, createInfinity, createLN10, createLOG10E, createMatrixClass, createNaN, createNull, createPhi, createRangeClass, createResultSet, createSQRT1_2, // eslint-disable-line camelcase
createSackurTetrode, createTau, createTrue, createVersion, createDenseMatrixClass, createEfimovFactor, createLN2, createPi, createReplacer, createSQRT2, createTyped, createUnaryPlus, createWeakMixingAngle, createAbs, createAcos, createAcot, createAcsc, createAddScalar, createArg, createAsech, createAsinh, createAtan, createAtanh, createBignumber, createBitNot, createBoolean, createClone, createCombinations, createComplex, createConj, createCosh, createCoth, createCsc, createCube, createEqualScalar, createErf, createExp, createExpm1, createFilter, createForEach, createFormat, createGetMatrixDataType, createHex, createIm, createIsInteger, createIsNegative, createIsPositive, createIsZero, createLOG2E, createLgamma, createLog10, createLog2, createMap, createMultiplyScalar, createNot, createNumber, createOct, createPickRandom, createPrint, createRandom, createRe, createSec, createSign, createSin, createSparseMatrixClass, createSplitUnit, createSquare, createString, createTan, createTypeOf, createAcosh, createAcsch, createApply, createAsec, createBin, createCombinationsWithRep, createCos, createCsch, createIsNaN, createIsPrime, createRandomInt, createSech, createSinh, createSparse, createSqrt, createTanh, createUnaryMinus, createAcoth, createCot, createFraction, createIsNumeric, createMatrix, createMatrixFromFunction, createMod, createNthRoot, createNumeric, createOr, createProd, createReshape, createSize, createSmaller, createSqueeze, createSubset, createSubtract, createTo, createTranspose, createXgcd, createZeros, createAnd, createBitAnd, createBitXor, createCbrt, createCompare, createCompareText, createConcat, createCount, createCtranspose, createDiag, createDivideScalar, createDotDivide, createEqual, createFlatten, createGcd, createHasNumericValue, createHypot, createImmutableDenseMatrixClass, createIndexClass, createKron, createLargerEq, createLeftShift, createLsolve, createMatrixFromColumns, createMin, createMode, createNthRoots, createOnes, createPartitionSelect, createResize, createRightArithShift, createRound, createSmallerEq, createUnequal, createUsolve, createXor, createAdd, createAtan2, createBitOr, createCatalan, createCompareNatural, createCumSum, createDeepEqual, createDiff, createDot, createEqualText, createFloor, createIdentity, createInvmod, createLarger, createLog, createLsolveAll, createMatrixFromRows, createMultiply, createQr, createRange, createRightLogShift, createRow, createSetCartesian, createSetDistinct, createSetIsSubset, createSetPowerset, createSlu, createSum, createTrace, createUsolveAll, createAsin, createCeil, createColumn, createComposition, createCross, createDet, createDistance, createDotMultiply, createFibonacciHeapClass, createFix, createIndex, createInv, createLcm, createLog1p, createMax, createPinv, createPow, createQuantileSeq, createSetDifference, createSetMultiplicity, createSetSymDifference, createSort, createSqrtm, createUnitClass, createVacuumImpedance, createWienDisplacement, createAtomicMass, createBohrMagneton, createBoltzmann, createConductanceQuantum, createCreateUnit, createDeuteronMass, createDotPow, createElectricConstant, createElementaryCharge, createExpm, createFaraday, createFirstRadiation, createGamma, createGravitationConstant, createHartreeEnergy, createIntersect, createKlitzing, createLoschmidt, createMagneticConstant, createMolarMass, createMolarPlanckConstant, createNeutronMass, createNuclearMagneton, createPlanckCharge, createPlanckLength, createPlanckTemperature, createProtonMass, createReducedPlanckConstant, createRydberg, createSetIntersect, createSetUnion, createSpaClass, createStefanBoltzmann, createThomsonCrossSection, createAvogadro, createBohrRadius, createCoulomb, createDivide, createElectronMass, createFactorial, createGravity, createInverseConductanceQuantum, createLup, createMagneticFluxQuantum, createMolarMassC12, createMultinomial, createPermutations, createPlanckMass, createQuantumOfCirculation, createSecondRadiation, createStirlingS2, createUnitFunction, createBellNumbers, createEigs, createFermiCoupling, createMean, createMolarVolume, createPlanckConstant, createSetSize, createSpeedOfLight, createVariance, createClassicalElectronRadius, createLusolve, createMedian, createGasConstant, createMad, createStd, createNorm, createRotationMatrix, createKldivergence, createRotate, createPlanckTime } from '../factoriesAny.js';
export var BigNumber = /* #__PURE__ */createBigNumberClass({
  config
});
export var Complex = /* #__PURE__ */createComplexClass({});
export var e = /* #__PURE__ */createE({
  BigNumber,
  config
});
export var _false = /* #__PURE__ */createFalse({});
export var fineStructure = /* #__PURE__ */createFineStructure({
  BigNumber,
  config
});
export var Fraction = /* #__PURE__ */createFractionClass({});
export var i = /* #__PURE__ */createI({
  Complex
});
export var _Infinity = /* #__PURE__ */createInfinity({
  BigNumber,
  config
});
export var LN10 = /* #__PURE__ */createLN10({
  BigNumber,
  config
});
export var LOG10E = /* #__PURE__ */createLOG10E({
  BigNumber,
  config
});
export var Matrix = /* #__PURE__ */createMatrixClass({});
export var _NaN = /* #__PURE__ */createNaN({
  BigNumber,
  config
});
export var _null = /* #__PURE__ */createNull({});
export var phi = /* #__PURE__ */createPhi({
  BigNumber,
  config
});
export var Range = /* #__PURE__ */createRangeClass({});
export var ResultSet = /* #__PURE__ */createResultSet({});
export var SQRT1_2 = /* #__PURE__ */createSQRT1_2({
  BigNumber,
  config
});
export var sackurTetrode = /* #__PURE__ */createSackurTetrode({
  BigNumber,
  config
});
export var tau = /* #__PURE__ */createTau({
  BigNumber,
  config
});
export var _true = /* #__PURE__ */createTrue({});
export var version = /* #__PURE__ */createVersion({});
export var DenseMatrix = /* #__PURE__ */createDenseMatrixClass({
  Matrix
});
export var efimovFactor = /* #__PURE__ */createEfimovFactor({
  BigNumber,
  config
});
export var LN2 = /* #__PURE__ */createLN2({
  BigNumber,
  config
});
export var pi = /* #__PURE__ */createPi({
  BigNumber,
  config
});
export var replacer = /* #__PURE__ */createReplacer({});
export var SQRT2 = /* #__PURE__ */createSQRT2({
  BigNumber,
  config
});
export var typed = /* #__PURE__ */createTyped({
  BigNumber,
  Complex,
  DenseMatrix,
  Fraction
});
export var unaryPlus = /* #__PURE__ */createUnaryPlus({
  BigNumber,
  config,
  typed
});
export var weakMixingAngle = /* #__PURE__ */createWeakMixingAngle({
  BigNumber,
  config
});
export var abs = /* #__PURE__ */createAbs({
  typed
});
export var acos = /* #__PURE__ */createAcos({
  Complex,
  config,
  typed
});
export var acot = /* #__PURE__ */createAcot({
  BigNumber,
  typed
});
export var acsc = /* #__PURE__ */createAcsc({
  BigNumber,
  Complex,
  config,
  typed
});
export var addScalar = /* #__PURE__ */createAddScalar({
  typed
});
export var arg = /* #__PURE__ */createArg({
  typed
});
export var asech = /* #__PURE__ */createAsech({
  BigNumber,
  Complex,
  config,
  typed
});
export var asinh = /* #__PURE__ */createAsinh({
  typed
});
export var atan = /* #__PURE__ */createAtan({
  typed
});
export var atanh = /* #__PURE__ */createAtanh({
  Complex,
  config,
  typed
});
export var bignumber = /* #__PURE__ */createBignumber({
  BigNumber,
  typed
});
export var bitNot = /* #__PURE__ */createBitNot({
  typed
});
export var boolean = /* #__PURE__ */createBoolean({
  typed
});
export var clone = /* #__PURE__ */createClone({
  typed
});
export var combinations = /* #__PURE__ */createCombinations({
  typed
});
export var complex = /* #__PURE__ */createComplex({
  Complex,
  typed
});
export var conj = /* #__PURE__ */createConj({
  typed
});
export var cosh = /* #__PURE__ */createCosh({
  typed
});
export var coth = /* #__PURE__ */createCoth({
  BigNumber,
  typed
});
export var csc = /* #__PURE__ */createCsc({
  BigNumber,
  typed
});
export var cube = /* #__PURE__ */createCube({
  typed
});
export var equalScalar = /* #__PURE__ */createEqualScalar({
  config,
  typed
});
export var erf = /* #__PURE__ */createErf({
  typed
});
export var exp = /* #__PURE__ */createExp({
  typed
});
export var expm1 = /* #__PURE__ */createExpm1({
  Complex,
  typed
});
export var filter = /* #__PURE__ */createFilter({
  typed
});
export var forEach = /* #__PURE__ */createForEach({
  typed
});
export var format = /* #__PURE__ */createFormat({
  typed
});
export var getMatrixDataType = /* #__PURE__ */createGetMatrixDataType({
  typed
});
export var hex = /* #__PURE__ */createHex({
  format,
  typed
});
export var im = /* #__PURE__ */createIm({
  typed
});
export var isInteger = /* #__PURE__ */createIsInteger({
  typed
});
export var isNegative = /* #__PURE__ */createIsNegative({
  typed
});
export var isPositive = /* #__PURE__ */createIsPositive({
  typed
});
export var isZero = /* #__PURE__ */createIsZero({
  typed
});
export var LOG2E = /* #__PURE__ */createLOG2E({
  BigNumber,
  config
});
export var lgamma = /* #__PURE__ */createLgamma({
  Complex,
  typed
});
export var log10 = /* #__PURE__ */createLog10({
  Complex,
  config,
  typed
});
export var log2 = /* #__PURE__ */createLog2({
  Complex,
  config,
  typed
});
export var map = /* #__PURE__ */createMap({
  typed
});
export var multiplyScalar = /* #__PURE__ */createMultiplyScalar({
  typed
});
export var not = /* #__PURE__ */createNot({
  typed
});
export var number = /* #__PURE__ */createNumber({
  typed
});
export var oct = /* #__PURE__ */createOct({
  format,
  typed
});
export var pickRandom = /* #__PURE__ */createPickRandom({
  config,
  typed
});
export var print = /* #__PURE__ */createPrint({
  typed
});
export var random = /* #__PURE__ */createRandom({
  config,
  typed
});
export var re = /* #__PURE__ */createRe({
  typed
});
export var sec = /* #__PURE__ */createSec({
  BigNumber,
  typed
});
export var sign = /* #__PURE__ */createSign({
  BigNumber,
  Fraction,
  complex,
  typed
});
export var sin = /* #__PURE__ */createSin({
  typed
});
export var SparseMatrix = /* #__PURE__ */createSparseMatrixClass({
  Matrix,
  equalScalar,
  typed
});
export var splitUnit = /* #__PURE__ */createSplitUnit({
  typed
});
export var square = /* #__PURE__ */createSquare({
  typed
});
export var string = /* #__PURE__ */createString({
  typed
});
export var tan = /* #__PURE__ */createTan({
  typed
});
export var typeOf = /* #__PURE__ */createTypeOf({
  typed
});
export var acosh = /* #__PURE__ */createAcosh({
  Complex,
  config,
  typed
});
export var acsch = /* #__PURE__ */createAcsch({
  BigNumber,
  typed
});
export var apply = /* #__PURE__ */createApply({
  isInteger,
  typed
});
export var asec = /* #__PURE__ */createAsec({
  BigNumber,
  Complex,
  config,
  typed
});
export var bin = /* #__PURE__ */createBin({
  format,
  typed
});
export var combinationsWithRep = /* #__PURE__ */createCombinationsWithRep({
  typed
});
export var cos = /* #__PURE__ */createCos({
  typed
});
export var csch = /* #__PURE__ */createCsch({
  BigNumber,
  typed
});
export var isNaN = /* #__PURE__ */createIsNaN({
  typed
});
export var isPrime = /* #__PURE__ */createIsPrime({
  typed
});
export var randomInt = /* #__PURE__ */createRandomInt({
  config,
  typed
});
export var sech = /* #__PURE__ */createSech({
  BigNumber,
  typed
});
export var sinh = /* #__PURE__ */createSinh({
  typed
});
export var sparse = /* #__PURE__ */createSparse({
  SparseMatrix,
  typed
});
export var sqrt = /* #__PURE__ */createSqrt({
  Complex,
  config,
  typed
});
export var tanh = /* #__PURE__ */createTanh({
  typed
});
export var unaryMinus = /* #__PURE__ */createUnaryMinus({
  typed
});
export var acoth = /* #__PURE__ */createAcoth({
  BigNumber,
  Complex,
  config,
  typed
});
export var cot = /* #__PURE__ */createCot({
  BigNumber,
  typed
});
export var fraction = /* #__PURE__ */createFraction({
  Fraction,
  typed
});
export var isNumeric = /* #__PURE__ */createIsNumeric({
  typed
});
export var matrix = /* #__PURE__ */createMatrix({
  DenseMatrix,
  Matrix,
  SparseMatrix,
  typed
});
export var matrixFromFunction = /* #__PURE__ */createMatrixFromFunction({
  isZero,
  matrix,
  typed
});
export var mod = /* #__PURE__ */createMod({
  DenseMatrix,
  equalScalar,
  matrix,
  typed
});
export var nthRoot = /* #__PURE__ */createNthRoot({
  BigNumber,
  equalScalar,
  matrix,
  typed
});
export var numeric = /* #__PURE__ */createNumeric({
  bignumber,
  fraction,
  number
});
export var or = /* #__PURE__ */createOr({
  DenseMatrix,
  equalScalar,
  matrix,
  typed
});
export var prod = /* #__PURE__ */createProd({
  config,
  multiplyScalar,
  numeric,
  typed
});
export var reshape = /* #__PURE__ */createReshape({
  isInteger,
  matrix,
  typed
});
export var size = /* #__PURE__ */createSize({
  matrix,
  config,
  typed
});
export var smaller = /* #__PURE__ */createSmaller({
  DenseMatrix,
  config,
  matrix,
  typed
});
export var squeeze = /* #__PURE__ */createSqueeze({
  matrix,
  typed
});
export var subset = /* #__PURE__ */createSubset({
  matrix,
  typed
});
export var subtract = /* #__PURE__ */createSubtract({
  DenseMatrix,
  addScalar,
  equalScalar,
  matrix,
  typed,
  unaryMinus
});
export var to = /* #__PURE__ */createTo({
  matrix,
  typed
});
export var transpose = /* #__PURE__ */createTranspose({
  matrix,
  typed
});
export var xgcd = /* #__PURE__ */createXgcd({
  BigNumber,
  config,
  matrix,
  typed
});
export var zeros = /* #__PURE__ */createZeros({
  BigNumber,
  config,
  matrix,
  typed
});
export var and = /* #__PURE__ */createAnd({
  equalScalar,
  matrix,
  not,
  typed,
  zeros
});
export var bitAnd = /* #__PURE__ */createBitAnd({
  equalScalar,
  matrix,
  typed
});
export var bitXor = /* #__PURE__ */createBitXor({
  DenseMatrix,
  matrix,
  typed
});
export var cbrt = /* #__PURE__ */createCbrt({
  BigNumber,
  Complex,
  Fraction,
  config,
  isNegative,
  matrix,
  typed,
  unaryMinus
});
export var compare = /* #__PURE__ */createCompare({
  BigNumber,
  DenseMatrix,
  Fraction,
  config,
  equalScalar,
  matrix,
  typed
});
export var compareText = /* #__PURE__ */createCompareText({
  matrix,
  typed
});
export var concat = /* #__PURE__ */createConcat({
  isInteger,
  matrix,
  typed
});
export var count = /* #__PURE__ */createCount({
  prod,
  size,
  typed
});
export var ctranspose = /* #__PURE__ */createCtranspose({
  conj,
  transpose,
  typed
});
export var diag = /* #__PURE__ */createDiag({
  DenseMatrix,
  SparseMatrix,
  matrix,
  typed
});
export var divideScalar = /* #__PURE__ */createDivideScalar({
  numeric,
  typed
});
export var dotDivide = /* #__PURE__ */createDotDivide({
  DenseMatrix,
  divideScalar,
  equalScalar,
  matrix,
  typed
});
export var equal = /* #__PURE__ */createEqual({
  DenseMatrix,
  equalScalar,
  matrix,
  typed
});
export var flatten = /* #__PURE__ */createFlatten({
  matrix,
  typed
});
export var gcd = /* #__PURE__ */createGcd({
  BigNumber,
  DenseMatrix,
  equalScalar,
  matrix,
  typed
});
export var hasNumericValue = /* #__PURE__ */createHasNumericValue({
  isNumeric,
  typed
});
export var hypot = /* #__PURE__ */createHypot({
  abs,
  addScalar,
  divideScalar,
  isPositive,
  multiplyScalar,
  smaller,
  sqrt,
  typed
});
export var ImmutableDenseMatrix = /* #__PURE__ */createImmutableDenseMatrixClass({
  DenseMatrix,
  smaller
});
export var Index = /* #__PURE__ */createIndexClass({
  ImmutableDenseMatrix
});
export var kron = /* #__PURE__ */createKron({
  matrix,
  multiplyScalar,
  typed
});
export var largerEq = /* #__PURE__ */createLargerEq({
  DenseMatrix,
  config,
  matrix,
  typed
});
export var leftShift = /* #__PURE__ */createLeftShift({
  DenseMatrix,
  equalScalar,
  matrix,
  typed,
  zeros
});
export var lsolve = /* #__PURE__ */createLsolve({
  DenseMatrix,
  divideScalar,
  equalScalar,
  matrix,
  multiplyScalar,
  subtract,
  typed
});
export var matrixFromColumns = /* #__PURE__ */createMatrixFromColumns({
  flatten,
  matrix,
  size,
  typed
});
export var min = /* #__PURE__ */createMin({
  config,
  numeric,
  smaller,
  typed
});
export var mode = /* #__PURE__ */createMode({
  isNaN,
  isNumeric,
  typed
});
export var nthRoots = /* #__PURE__ */createNthRoots({
  Complex,
  config,
  divideScalar,
  typed
});
export var ones = /* #__PURE__ */createOnes({
  BigNumber,
  config,
  matrix,
  typed
});
export var partitionSelect = /* #__PURE__ */createPartitionSelect({
  compare,
  isNaN,
  isNumeric,
  typed
});
export var resize = /* #__PURE__ */createResize({
  config,
  matrix
});
export var rightArithShift = /* #__PURE__ */createRightArithShift({
  DenseMatrix,
  equalScalar,
  matrix,
  typed,
  zeros
});
export var round = /* #__PURE__ */createRound({
  BigNumber,
  DenseMatrix,
  equalScalar,
  matrix,
  typed,
  zeros
});
export var smallerEq = /* #__PURE__ */createSmallerEq({
  DenseMatrix,
  config,
  matrix,
  typed
});
export var unequal = /* #__PURE__ */createUnequal({
  DenseMatrix,
  config,
  equalScalar,
  matrix,
  typed
});
export var usolve = /* #__PURE__ */createUsolve({
  DenseMatrix,
  divideScalar,
  equalScalar,
  matrix,
  multiplyScalar,
  subtract,
  typed
});
export var xor = /* #__PURE__ */createXor({
  DenseMatrix,
  matrix,
  typed
});
export var add = /* #__PURE__ */createAdd({
  DenseMatrix,
  SparseMatrix,
  addScalar,
  equalScalar,
  matrix,
  typed
});
export var atan2 = /* #__PURE__ */createAtan2({
  BigNumber,
  DenseMatrix,
  equalScalar,
  matrix,
  typed
});
export var bitOr = /* #__PURE__ */createBitOr({
  DenseMatrix,
  equalScalar,
  matrix,
  typed
});
export var catalan = /* #__PURE__ */createCatalan({
  addScalar,
  combinations,
  divideScalar,
  isInteger,
  isNegative,
  multiplyScalar,
  typed
});
export var compareNatural = /* #__PURE__ */createCompareNatural({
  compare,
  typed
});
export var cumsum = /* #__PURE__ */createCumSum({
  add,
  typed,
  unaryPlus
});
export var deepEqual = /* #__PURE__ */createDeepEqual({
  equal,
  typed
});
export var diff = /* #__PURE__ */createDiff({
  matrix,
  number,
  subtract,
  typed
});
export var dot = /* #__PURE__ */createDot({
  addScalar,
  conj,
  multiplyScalar,
  size,
  typed
});
export var equalText = /* #__PURE__ */createEqualText({
  compareText,
  isZero,
  typed
});
export var floor = /* #__PURE__ */createFloor({
  DenseMatrix,
  config,
  equalScalar,
  matrix,
  round,
  typed,
  zeros
});
export var identity = /* #__PURE__ */createIdentity({
  BigNumber,
  DenseMatrix,
  SparseMatrix,
  config,
  matrix,
  typed
});
export var invmod = /* #__PURE__ */createInvmod({
  BigNumber,
  add,
  config,
  equal,
  isInteger,
  mod,
  smaller,
  typed,
  xgcd
});
export var larger = /* #__PURE__ */createLarger({
  DenseMatrix,
  config,
  matrix,
  typed
});
export var log = /* #__PURE__ */createLog({
  Complex,
  config,
  divideScalar,
  typed
});
export var lsolveAll = /* #__PURE__ */createLsolveAll({
  DenseMatrix,
  divideScalar,
  equalScalar,
  matrix,
  multiplyScalar,
  subtract,
  typed
});
export var matrixFromRows = /* #__PURE__ */createMatrixFromRows({
  flatten,
  matrix,
  size,
  typed
});
export var multiply = /* #__PURE__ */createMultiply({
  addScalar,
  dot,
  equalScalar,
  matrix,
  multiplyScalar,
  typed
});
export var qr = /* #__PURE__ */createQr({
  addScalar,
  complex,
  conj,
  divideScalar,
  equal,
  identity,
  isZero,
  matrix,
  multiplyScalar,
  sign,
  sqrt,
  subtract,
  typed,
  unaryMinus,
  zeros
});
export var range = /* #__PURE__ */createRange({
  bignumber,
  matrix,
  config,
  larger,
  largerEq,
  smaller,
  smallerEq,
  typed
});
export var rightLogShift = /* #__PURE__ */createRightLogShift({
  DenseMatrix,
  equalScalar,
  matrix,
  typed,
  zeros
});
export var row = /* #__PURE__ */createRow({
  Index,
  matrix,
  range,
  typed
});
export var setCartesian = /* #__PURE__ */createSetCartesian({
  DenseMatrix,
  Index,
  compareNatural,
  size,
  subset,
  typed
});
export var setDistinct = /* #__PURE__ */createSetDistinct({
  DenseMatrix,
  Index,
  compareNatural,
  size,
  subset,
  typed
});
export var setIsSubset = /* #__PURE__ */createSetIsSubset({
  Index,
  compareNatural,
  size,
  subset,
  typed
});
export var setPowerset = /* #__PURE__ */createSetPowerset({
  Index,
  compareNatural,
  size,
  subset,
  typed
});
export var slu = /* #__PURE__ */createSlu({
  SparseMatrix,
  abs,
  add,
  divideScalar,
  larger,
  largerEq,
  multiply,
  subtract,
  transpose,
  typed
});
export var sum = /* #__PURE__ */createSum({
  add,
  config,
  numeric,
  typed
});
export var trace = /* #__PURE__ */createTrace({
  add,
  matrix,
  typed
});
export var usolveAll = /* #__PURE__ */createUsolveAll({
  DenseMatrix,
  divideScalar,
  equalScalar,
  matrix,
  multiplyScalar,
  subtract,
  typed
});
export var asin = /* #__PURE__ */createAsin({
  Complex,
  config,
  typed
});
export var ceil = /* #__PURE__ */createCeil({
  DenseMatrix,
  config,
  equalScalar,
  matrix,
  round,
  typed,
  zeros
});
export var column = /* #__PURE__ */createColumn({
  Index,
  matrix,
  range,
  typed
});
export var composition = /* #__PURE__ */createComposition({
  addScalar,
  combinations,
  isInteger,
  isNegative,
  isPositive,
  larger,
  typed
});
export var cross = /* #__PURE__ */createCross({
  matrix,
  multiply,
  subtract,
  typed
});
export var det = /* #__PURE__ */createDet({
  divideScalar,
  isZero,
  matrix,
  multiply,
  subtract,
  typed,
  unaryMinus
});
export var distance = /* #__PURE__ */createDistance({
  abs,
  addScalar,
  divideScalar,
  multiplyScalar,
  sqrt,
  subtract,
  typed,
  unaryMinus
});
export var dotMultiply = /* #__PURE__ */createDotMultiply({
  equalScalar,
  matrix,
  multiplyScalar,
  typed
});
export var FibonacciHeap = /* #__PURE__ */createFibonacciHeapClass({
  larger,
  smaller
});
export var fix = /* #__PURE__ */createFix({
  Complex,
  DenseMatrix,
  ceil,
  equalScalar,
  floor,
  matrix,
  typed,
  zeros
});
export var index = /* #__PURE__ */createIndex({
  Index,
  typed
});
export var inv = /* #__PURE__ */createInv({
  abs,
  addScalar,
  det,
  divideScalar,
  identity,
  matrix,
  multiply,
  typed,
  unaryMinus
});
export var lcm = /* #__PURE__ */createLcm({
  equalScalar,
  matrix,
  typed
});
export var log1p = /* #__PURE__ */createLog1p({
  Complex,
  config,
  divideScalar,
  log,
  typed
});
export var max = /* #__PURE__ */createMax({
  config,
  larger,
  numeric,
  typed
});
export var pinv = /* #__PURE__ */createPinv({
  Complex,
  add,
  ctranspose,
  deepEqual,
  divideScalar,
  dot,
  dotDivide,
  equal,
  inv,
  matrix,
  multiply,
  typed
});
export var pow = /* #__PURE__ */createPow({
  Complex,
  config,
  fraction,
  identity,
  inv,
  matrix,
  multiply,
  number,
  typed
});
export var quantileSeq = /* #__PURE__ */createQuantileSeq({
  add,
  compare,
  multiply,
  partitionSelect,
  typed
});
export var setDifference = /* #__PURE__ */createSetDifference({
  DenseMatrix,
  Index,
  compareNatural,
  size,
  subset,
  typed
});
export var setMultiplicity = /* #__PURE__ */createSetMultiplicity({
  Index,
  compareNatural,
  size,
  subset,
  typed
});
export var setSymDifference = /* #__PURE__ */createSetSymDifference({
  Index,
  concat,
  setDifference,
  size,
  subset,
  typed
});
export var sort = /* #__PURE__ */createSort({
  compare,
  compareNatural,
  matrix,
  typed
});
export var sqrtm = /* #__PURE__ */createSqrtm({
  abs,
  add,
  identity,
  inv,
  max,
  multiply,
  size,
  sqrt,
  subtract,
  typed
});
export var Unit = /* #__PURE__ */createUnitClass({
  BigNumber,
  Complex,
  Fraction,
  abs,
  addScalar,
  config,
  divideScalar,
  equal,
  fix,
  format,
  isNumeric,
  multiplyScalar,
  number,
  pow,
  round,
  subtract
});
export var vacuumImpedance = /* #__PURE__ */createVacuumImpedance({
  BigNumber,
  Unit,
  config
});
export var wienDisplacement = /* #__PURE__ */createWienDisplacement({
  BigNumber,
  Unit,
  config
});
export var atomicMass = /* #__PURE__ */createAtomicMass({
  BigNumber,
  Unit,
  config
});
export var bohrMagneton = /* #__PURE__ */createBohrMagneton({
  BigNumber,
  Unit,
  config
});
export var boltzmann = /* #__PURE__ */createBoltzmann({
  BigNumber,
  Unit,
  config
});
export var conductanceQuantum = /* #__PURE__ */createConductanceQuantum({
  BigNumber,
  Unit,
  config
});
export var createUnit = /* #__PURE__ */createCreateUnit({
  Unit,
  typed
});
export var deuteronMass = /* #__PURE__ */createDeuteronMass({
  BigNumber,
  Unit,
  config
});
export var dotPow = /* #__PURE__ */createDotPow({
  DenseMatrix,
  equalScalar,
  matrix,
  pow,
  typed
});
export var electricConstant = /* #__PURE__ */createElectricConstant({
  BigNumber,
  Unit,
  config
});
export var elementaryCharge = /* #__PURE__ */createElementaryCharge({
  BigNumber,
  Unit,
  config
});
export var expm = /* #__PURE__ */createExpm({
  abs,
  add,
  identity,
  inv,
  multiply,
  typed
});
export var faraday = /* #__PURE__ */createFaraday({
  BigNumber,
  Unit,
  config
});
export var firstRadiation = /* #__PURE__ */createFirstRadiation({
  BigNumber,
  Unit,
  config
});
export var gamma = /* #__PURE__ */createGamma({
  BigNumber,
  Complex,
  config,
  multiplyScalar,
  pow,
  typed
});
export var gravitationConstant = /* #__PURE__ */createGravitationConstant({
  BigNumber,
  Unit,
  config
});
export var hartreeEnergy = /* #__PURE__ */createHartreeEnergy({
  BigNumber,
  Unit,
  config
});
export var intersect = /* #__PURE__ */createIntersect({
  abs,
  add,
  addScalar,
  config,
  divideScalar,
  equalScalar,
  flatten,
  isNumeric,
  isZero,
  matrix,
  multiply,
  multiplyScalar,
  smaller,
  subtract,
  typed
});
export var klitzing = /* #__PURE__ */createKlitzing({
  BigNumber,
  Unit,
  config
});
export var loschmidt = /* #__PURE__ */createLoschmidt({
  BigNumber,
  Unit,
  config
});
export var magneticConstant = /* #__PURE__ */createMagneticConstant({
  BigNumber,
  Unit,
  config
});
export var molarMass = /* #__PURE__ */createMolarMass({
  BigNumber,
  Unit,
  config
});
export var molarPlanckConstant = /* #__PURE__ */createMolarPlanckConstant({
  BigNumber,
  Unit,
  config
});
export var neutronMass = /* #__PURE__ */createNeutronMass({
  BigNumber,
  Unit,
  config
});
export var nuclearMagneton = /* #__PURE__ */createNuclearMagneton({
  BigNumber,
  Unit,
  config
});
export var planckCharge = /* #__PURE__ */createPlanckCharge({
  BigNumber,
  Unit,
  config
});
export var planckLength = /* #__PURE__ */createPlanckLength({
  BigNumber,
  Unit,
  config
});
export var planckTemperature = /* #__PURE__ */createPlanckTemperature({
  BigNumber,
  Unit,
  config
});
export var protonMass = /* #__PURE__ */createProtonMass({
  BigNumber,
  Unit,
  config
});
export var reducedPlanckConstant = /* #__PURE__ */createReducedPlanckConstant({
  BigNumber,
  Unit,
  config
});
export var rydberg = /* #__PURE__ */createRydberg({
  BigNumber,
  Unit,
  config
});
export var setIntersect = /* #__PURE__ */createSetIntersect({
  DenseMatrix,
  Index,
  compareNatural,
  size,
  subset,
  typed
});
export var setUnion = /* #__PURE__ */createSetUnion({
  Index,
  concat,
  setIntersect,
  setSymDifference,
  size,
  subset,
  typed
});
export var Spa = /* #__PURE__ */createSpaClass({
  FibonacciHeap,
  addScalar,
  equalScalar
});
export var stefanBoltzmann = /* #__PURE__ */createStefanBoltzmann({
  BigNumber,
  Unit,
  config
});
export var thomsonCrossSection = /* #__PURE__ */createThomsonCrossSection({
  BigNumber,
  Unit,
  config
});
export var avogadro = /* #__PURE__ */createAvogadro({
  BigNumber,
  Unit,
  config
});
export var bohrRadius = /* #__PURE__ */createBohrRadius({
  BigNumber,
  Unit,
  config
});
export var coulomb = /* #__PURE__ */createCoulomb({
  BigNumber,
  Unit,
  config
});
export var divide = /* #__PURE__ */createDivide({
  divideScalar,
  equalScalar,
  inv,
  matrix,
  multiply,
  typed
});
export var electronMass = /* #__PURE__ */createElectronMass({
  BigNumber,
  Unit,
  config
});
export var factorial = /* #__PURE__ */createFactorial({
  gamma,
  typed
});
export var gravity = /* #__PURE__ */createGravity({
  BigNumber,
  Unit,
  config
});
export var inverseConductanceQuantum = /* #__PURE__ */createInverseConductanceQuantum({
  BigNumber,
  Unit,
  config
});
export var lup = /* #__PURE__ */createLup({
  DenseMatrix,
  Spa,
  SparseMatrix,
  abs,
  addScalar,
  divideScalar,
  equalScalar,
  larger,
  matrix,
  multiplyScalar,
  subtract,
  typed,
  unaryMinus
});
export var magneticFluxQuantum = /* #__PURE__ */createMagneticFluxQuantum({
  BigNumber,
  Unit,
  config
});
export var molarMassC12 = /* #__PURE__ */createMolarMassC12({
  BigNumber,
  Unit,
  config
});
export var multinomial = /* #__PURE__ */createMultinomial({
  add,
  divide,
  factorial,
  isInteger,
  isPositive,
  multiply,
  typed
});
export var permutations = /* #__PURE__ */createPermutations({
  factorial,
  typed
});
export var planckMass = /* #__PURE__ */createPlanckMass({
  BigNumber,
  Unit,
  config
});
export var quantumOfCirculation = /* #__PURE__ */createQuantumOfCirculation({
  BigNumber,
  Unit,
  config
});
export var secondRadiation = /* #__PURE__ */createSecondRadiation({
  BigNumber,
  Unit,
  config
});
export var stirlingS2 = /* #__PURE__ */createStirlingS2({
  bignumber,
  addScalar,
  combinations,
  divideScalar,
  factorial,
  isInteger,
  isNegative,
  larger,
  multiplyScalar,
  number,
  pow,
  subtract,
  typed
});
export var unit = /* #__PURE__ */createUnitFunction({
  Unit,
  typed
});
export var bellNumbers = /* #__PURE__ */createBellNumbers({
  addScalar,
  isInteger,
  isNegative,
  stirlingS2,
  typed
});
export var eigs = /* #__PURE__ */createEigs({
  abs,
  add,
  addScalar,
  atan,
  bignumber,
  column,
  complex,
  config,
  cos,
  diag,
  divideScalar,
  dot,
  equal,
  flatten,
  im,
  inv,
  larger,
  matrix,
  matrixFromColumns,
  multiply,
  multiplyScalar,
  number,
  qr,
  re,
  sin,
  smaller,
  sqrt,
  subtract,
  typed,
  usolve,
  usolveAll
});
export var fermiCoupling = /* #__PURE__ */createFermiCoupling({
  BigNumber,
  Unit,
  config
});
export var mean = /* #__PURE__ */createMean({
  add,
  divide,
  typed
});
export var molarVolume = /* #__PURE__ */createMolarVolume({
  BigNumber,
  Unit,
  config
});
export var planckConstant = /* #__PURE__ */createPlanckConstant({
  BigNumber,
  Unit,
  config
});
export var setSize = /* #__PURE__ */createSetSize({
  compareNatural,
  typed
});
export var speedOfLight = /* #__PURE__ */createSpeedOfLight({
  BigNumber,
  Unit,
  config
});
export var variance = /* #__PURE__ */createVariance({
  add,
  apply,
  divide,
  isNaN,
  multiply,
  subtract,
  typed
});
export var classicalElectronRadius = /* #__PURE__ */createClassicalElectronRadius({
  BigNumber,
  Unit,
  config
});
export var lusolve = /* #__PURE__ */createLusolve({
  DenseMatrix,
  lsolve,
  lup,
  matrix,
  slu,
  typed,
  usolve
});
export var median = /* #__PURE__ */createMedian({
  add,
  compare,
  divide,
  partitionSelect,
  typed
});
export var gasConstant = /* #__PURE__ */createGasConstant({
  BigNumber,
  Unit,
  config
});
export var mad = /* #__PURE__ */createMad({
  abs,
  map,
  median,
  subtract,
  typed
});
export var std = /* #__PURE__ */createStd({
  sqrt,
  typed,
  variance
});
export var norm = /* #__PURE__ */createNorm({
  abs,
  add,
  conj,
  ctranspose,
  eigs,
  equalScalar,
  larger,
  matrix,
  multiply,
  pow,
  smaller,
  sqrt,
  typed
});
export var rotationMatrix = /* #__PURE__ */createRotationMatrix({
  BigNumber,
  DenseMatrix,
  SparseMatrix,
  addScalar,
  config,
  cos,
  matrix,
  multiplyScalar,
  norm,
  sin,
  typed,
  unaryMinus
});
export var kldivergence = /* #__PURE__ */createKldivergence({
  divide,
  dotDivide,
  isNumeric,
  log,
  matrix,
  multiply,
  sum,
  typed
});
export var rotate = /* #__PURE__ */createRotate({
  multiply,
  rotationMatrix,
  typed
});
export var planckTime = /* #__PURE__ */createPlanckTime({
  BigNumber,
  Unit,
  config
});